// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__PGz4w","recordRow":"styles_recordRow__0r4Qm"};